<template>
  <div>
    <v-card elevation="6" class="base-card-container pa-0 mt-4">
      <v-card color="primary">
        <v-card-title class="card-title-style">
          Agregar Movimiento
        </v-card-title>
      </v-card>
      <v-form ref="form" v-model="validForm" lazy-validation>
        <v-card-text>
          <v-row justify="center" v-if="loaded == false">
            <v-col cols="12" md="7">
              <v-skeleton-loader
                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row justify="center" v-if="loaded == true">
            <v-col cols="12" md="7">
              <div>
                <span class="type-label-style">{{
                  encabezadoText[0].txtLabel
                }}</span>
                <p class="type-text-style">{{ encabezadoText[1].txtLabel }}</p>
              </div>
              <v-divider class="mt-1"></v-divider>

              <div>
                <span class="type-label-style">Respuesta:</span>
                <p class="type-text-style">{{ respuestaText }}</p>
              </div>
              <v-divider class="mt-1"></v-divider>

              <div class="my-5">
                <span class="type-label-style">Fecha de diligencia/documentos:</span>
                <v-dialog ref="mainDateDialog" v-model="menuDatePickerGeneral" :return-value.sync="selectedDate"
                  persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="selectedDate" readonly solo v-bind="attrs" v-on="on">
                      <template v-slot:prepend>
                        <v-icon color="primary">mdi-calendar</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="selectedDate" :min="dateComponentConstraints.fechaMinima"
                    :max="dateComponentConstraints.fechaMaxima" locale="es-MX">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menuDatePickerGeneral = false">
                      Cancelar
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.mainDateDialog.save(selectedDate)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </div>
              <v-divider class="mt-1"></v-divider>
              <div v-if="mostrarPrestaciones">
                <div v-for="(prestacion, index) in prestaciones" :key="index">
                  <v-row class="mt-1">
                    <v-col cols="12" md="6" style="display: flex; align-items: center">
                      <span class="type-label-style">{{ prestacion.opconcepto }}:</span>
                    </v-col>
                  </v-row>
                  <v-row class="mx-1">
                    <v-select solo :items="opcionesPr" item-value="valor" item-text="descripcion"
                      placeholder="Selecciona una opción" :value="opcionesPr.valor" v-model="prestacion.pciRespuesta"
                      @change="selectValueChangeTrigger(prestacion,
                        opcionesPr.valor,
                        index)">
                    </v-select>
                  </v-row>
                </div>
                <div v-if="errorPrestacion">
                  <span class="error-message-style mb-3">Debe de almenos llenar una prestación.</span>
                </div>
              </div>
              <div v-if="mostrarfechas == true">
                <div v-for="(prueba, index) in pruebas" :key="index">
                  <v-row class="mt-1">
                    <v-col cols="12" md="6" style="display: flex; align-items: center">
                      <span class="type-label-style">{{ prueba.opconcepto }}:</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-dialog ref="datePruebas" v-model="prueba.dialog" :return-value.sync="prueba.fecha" persistent
                      width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="prueba.fecha" readonly solo v-bind="attrs" v-on="on"
                          :rules="campoRequeridoRules">
                          <template v-slot:prepend>
                            <v-icon color="primary">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="prueba.fecha" :min="dateComponentConstraints.fechaMinima" locale="es-MX">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="prueba.dialog = false">
                          Cancelar
                        </v-btn>
                        <v-btn text color="primary" @click="$refs.datePruebas[index].save(prueba.fecha)">
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-row>
                </div>

              </div>
              <div>
                <div v-if="documentosTag == true" class="mt-5">
                  <span class="type-label-style" v-if="inputDinamicos != undefined">
                    Documentos:
                  </span>
                </div>
                <v-row>
                  <v-col v-for="(item, index) in inputDinamicos" :key="index" lg="3" md="6" cols="12">
                    <v-checkbox v-if="item.tipoInput == 'checkbox'" @click="inputDinamicosCheck(index, item)"
                      v-model="dynamicInputVmodels[index].valor" :disabled="documentosPoderAusa == true
                        ? item.idNombre == 'chDoctosAusa'
                          ? false
                          : true
                        : false
                        " @change="
                          docCheckBoxInput(
                            dynamicInputVmodels[index].valor,
                            item.valor,
                            item
                          )
                          ">
                      <template slot="label">
                        <span class="document-chekboxes-style">
                          {{ item.txtlabel }}
                        </span>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
                <div v-if="enableFacturaFisicaRadio == true">
                  <span class="type-label-style">Factura Fisica: </span>
                  <v-row class="px-5 mb-4">
                    <v-switch v-model="facturaFisicaRadioValue" inset persistent-hint
                      :hint="facturaFisicaRadioValue == true ? 'Si' : 'No'"></v-switch>
                  </v-row>
                </div>
                <v-row v-if="tokenClaveMovimiento == 757">
                  <v-col v-for="(item, index) in inputDinamicos" :key="index" cols="12" lg="3" md="6" sm="6">
                    <div v-if="item.tipoInput == 'label'">
                      <span class="document-chekboxes-style">
                        {{ item.txtLabel }}
                      </span>
                      <v-text-field outlined disabled v-model="item.valor">
                      </v-text-field>
                    </div>

                    <div v-if="item.tipoInput == 'select'">
                      <span class="document-chekboxes-style">
                        {{ item.txtLabel }}
                      </span>
                      <v-select outlined required :items="dynamicInputVmodels[index].opciones" item-value="valor"
                        item-text="descripcion" placeholder="Selecciona una opción"
                        v-model="dynamicInputVmodels[index].valor" :value="dynamicInputVmodels[index].valor"
                        :rules="dynamicRulesGen(item, index)">
                      </v-select>
                    </div>
                  </v-col>
                </v-row>
                <div v-if="documentosTag == true && dynamicInputsErrorMessage == true
                ">
                  <span class="error-message-style mb-3">
                    {{ dynamicInputsErrorMessageText }}
                  </span>
                </div>
              </div>
              <v-row class="mt-4" v-if="documentosPoderAusa == false">
                <div v-for="(item, index) in extraDataItems" :key="index" :class="'mt-2 ' + item.size != null
                  ? 'col-12 col-md-' + item.size
                  : ''
                  ">
                  <div id="texFieldType" v-if="item.tipoInput == 'textfield' && showInput">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-text-field v-on:blur="
                      extraDataItems[index].textType == 'number'
                        ? null
                        : dynamicVModels[index].valor != null
                          ? dynamicVModels[index].valor != ''
                            ? dynamicVModels[index].valor.trim()
                            : null
                          : null
                      " :rules="dynamicRulesGen(item, index)" :type="extraDataItems[index].textType != undefined
                        ? extraDataItems[index].textType
                        : 'text'
                        " solo v-model="dynamicVModels[index].valor">
                    </v-text-field>
                  </div>
                  <div id="multiselect" v-if="item.tipoInput == 'multiselect' && item.idNombre == 'sEstado'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <multiselect v-model="dynamicVModels[index].valor"
                      deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                      select-label="Seleccione una opción" track-by="clave" label="desc"
                      placeholder="Seleccione una opción" :options="opciones.Catalogo" :allow-empty="false" dense
                      class="multiselectEstados" @select="ObtenerLocalidad">
                    </multiselect>
                    <span v-if="validaEstado" class="spanError" style="color: red; font-size: 11px">Campo
                      requerido</span>
                  </div>
                  <div id="multiselect" v-if="item.tipoInput == 'multiselect' && item.idNombre == 'sLocalidad'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <multiselect v-model="dynamicVModels[index].valor"
                      deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                      select-label="Seleccione una opción" track-by="clave" label="desc"
                      placeholder="Seleccione una opción" :options="opcionesLocalidad.Catalogo" :allow-empty="false"
                      dense class="multiselectEstados" :disabled="dislocalidad" @select="SeleccionarLocalidad">
                    </multiselect>
                    <span v-if="validaLocalidad" class="spanError" style="color: red; font-size: 11px">Campo
                      requerido</span>
                  </div>
                  <div id="multiselect" v-if="item.tipoInput == 'multiselect' && item.idNombre == 'sAfianzadoraC'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <multiselect v-model="dynamicVModels[index].valor"
                      deselect-label="No se puede remover el valor seleccionado" selected-label="Seleccionado"
                      select-label="Seleccionar valor" track-by="afclave" label="afnombre"
                      placeholder="Seleccionar Afinazadora" :options="afianzadorasArray" :allow-empty="true"
                      @select="SeleccionarAfianzadora">
                    </multiselect>
                    <span v-if="validaAfianzadora" class="spanError" style="color: red; font-size: 11px">Campo
                      requerido</span>
                  </div>
                  <div v-if="item.tipoInput == 'datepicker'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-dialog ref="dDatePicker" v-model="DatePicker" :return-value.sync="dynamicVModels[index].valor"
                      persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="dynamicVModels[index].valor" readonly solo v-bind="attrs" v-on="on"
                          :rules="campoRequeridoRules">
                          <template v-slot:prepend>
                            <v-icon color="primary">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="dynamicVModels[index].valor" :min="dateComponentConstraints.fechaMinima"
                        locale="es-MX">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="DatePicker = false">
                          Cancelar
                        </v-btn>
                        <v-btn text color="primary" @click="
                          $refs.dDatePicker[0].save(
                            dynamicVModels[index].valor
                          )
                          ">
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </div>

                  <div id="selectType" v-if="item.tipoInput == 'select'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-select solo :rules="dynamicRulesGen(item, index)" v-model="dynamicVModels[index].valor"
                      :multiple=item.multiple :items="dynamicVModels[index].opciones" item-text="descripcion"
                      item-value="valor" @change="
                        selectValueChangeTrigger(
                          item,
                          dynamicVModels[index].valor,
                          index
                        )
                        "></v-select>
                    <div v-for="(subitem, subindex) in subElementoDynamicVModels[
                      index
                    ]" :key="subindex">
                      <div id="subtexFieldType" v-if="subitem.tipoInput == 'textfield'">
                        <span class="type-label-style">{{
                          subitem.txtLabel
                        }}</span>
                        <v-text-field v-on:blur="
                          subElementoDynamicVModels[index][subindex]
                            .textType == 'number'
                            ? null
                            : subElementoDynamicVModels[index][subindex]
                              .valor != null
                              ? subElementoDynamicVModels[index][subindex]
                                .valor != ''
                                ? subElementoDynamicVModels[index][
                                  subindex
                                ].valor.trim()
                                : null
                              : null
                          " :rules="dynamicRulesGen(subitem, subindex)" :type="subElementoDynamicVModels[index][subindex]
                            .textType != undefined
                            ? subElementoDynamicVModels[index][subindex]
                              .textType
                            : 'text'
                            " solo v-model="subElementoDynamicVModels[index][subindex].valor
                              ">
                        </v-text-field>
                      </div>
                    </div>
                    <div v-if="showAudienciaAcordada == true &&
                      item.idNombre == 'sRespAudi'
                    ">
                      <div v-for="(item, index) in audienciaAcordadaItems" :key="index">
                        <div v-if="item.tipoInput == 'datepicker'">
                          <span class="type-label-style">Fecha Audiencia:</span>
                          <v-dialog ref="audiDatePicker" v-model="audicienciaPicker"
                            :return-value.sync="fechaAudienciaSelected" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field v-model="fechaAudienciaSelected" readonly solo v-bind="attrs" v-on="on"
                                :rules="campoRequeridoRules">
                                <template v-slot:prepend>
                                  <v-icon color="primary">mdi-calendar</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker v-model="fechaAudienciaSelected" :min="dateComponentConstraints.fechaMaxima"
                              locale="es-MX">
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="audicienciaPicker = false">
                                Cancelar
                              </v-btn>
                              <v-btn text color="primary" @click="
                                $refs.audiDatePicker[0].save(
                                  fechaAudienciaSelected
                                )
                                ">
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </div>
                        <div v-if="item.tipoInput == 'timepicker'">
                          <span class="type-label-style">Hora Audiencia:</span>
                          <v-dialog ref="audiTimePicker" v-model="audicienciaTimePicker"
                            :return-value.sync="horaAudienciaSelected" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field :rules="campoRequeridoRules" v-model="horaAudienciaSelected" readonly solo
                                v-bind="attrs" v-on="on">
                                <template v-slot:prepend>
                                  <v-icon color="primary">mdi-clock</v-icon>
                                </template>
                              </v-text-field>
                            </template>
                            <v-time-picker v-model="horaAudienciaSelected" format="24hr" locale="es-MX" min="8:00"
                              max="20:00">
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="audicienciaTimePicker = false">
                                Cancelar
                              </v-btn>
                              <v-btn text color="primary" @click="
                                $refs.audiTimePicker[0].save(
                                  horaAudienciaSelected
                                )
                                ">
                                OK
                              </v-btn>
                            </v-time-picker>
                          </v-dialog>
                        </div>
                        <!--  END OF AUDIENCIA DATE/TIME -->
                      </div>
                    </div>
                    <div v-if="responsabilidadState == true &&
                      item.idNombre.toString().toLowerCase() == 'sdiccausalidad'
                    ">
                      <div v-if="dynamicVModels[index].valor == 2">
                        <span class="type-label-style">¿El tercero acepta responsabilidad?
                        </span>
                        <v-row class="px-5 mb-4">
                          <v-switch v-model="responsabilidadTercero" inset persistent-hint
                            :hint="responsabilidadTercero == true ? 'Si' : 'No'"></v-switch>
                        </v-row>
                      </div>
                      <div v-if="dynamicVModels[index].valor == 3">
                        <span class="type-label-style">¿El NA acepta responsabilidad?</span>
                        <v-row class="px-5 mb-4">
                          <v-switch v-model="responsabilidadNa" inset persistent-hint
                            :hint="responsabilidadNa == true ? 'Si' : 'No'"></v-switch>
                        </v-row>
                      </div>
                      <div v-if="dynamicVModels[index].valor == 4">
                        <span class="type-label-style">¿El tercero acepta responsabilidad?</span>
                        <v-row class="px-5 mb-2">
                          <v-switch v-model="responsabilidadTercero" inset persistent-hint
                            :hint="responsabilidadTercero == true ? 'Si' : 'No'"></v-switch>
                        </v-row>
                        <span class="type-label-style">¿El NA acepta responsabilidad?</span>
                        <v-row class="px-5 mb-4">
                          <v-switch v-model="responsabilidadNa" inset persistent-hint
                            :hint="responsabilidadNa == true ? 'Si' : 'No'"></v-switch>
                        </v-row>
                      </div>
                    </div>
                  </div>
                  <div id="radiobutton" v-if="item.tipoInput == 'radio' && tokenClaveMovimiento == 848
                  ">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-radio-group v-model="respuesta" row>
                      <v-radio label="SI" value="1"></v-radio>
                      <v-radio label="NO" value="0"></v-radio>
                    </v-radio-group>
                    <span v-if="validarespuesta" class="spanError" style="color: red; font-size: 11px">Campo
                      requerido</span>
                    <v-divider class="mt-1"></v-divider>
                  </div>
                  <div cols="12" md="7" id="mailTextField" v-if="item.tipoInput == 'mailTextfield'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-autocomplete solo chips clearable deletable-chips :rules="dynamicRulesGen(item, index)"
                      :items="dynamicVModels[index].items" v-model="dynamicVModels[index].valor"
                      :search-input.sync="dynamicVModels[index].searchIteam" no-data-text="Introduzca un correo válido"
                      @change="resetItemsSelector($event, item, index)"
                      @keyup="addMailValider($event, item, index)"></v-autocomplete>
                    <v-chip class="ma-2" close color="#536DFE" dark v-for="(chips, chipIndex) in dynamicVModels[index]
                      .selectedItems" :key="chipIndex" @click:close="deleteFromList(index, chips)">
                      {{ chips }}
                    </v-chip>
                  </div>
                  <div id="selectType" v-if="item.tipoInput == 'selectCorreos'">
                    <div style="height: 22px"></div>
                    <v-select solo :rules="dynamicRulesGen(item, index)" v-model="dynamicVModels[index].valor"
                      :items="dynamicVModels[index].opciones" item-text="descripcion" item-value="valorZona" @change="
                        newSelectedMails(dynamicVModels[index].valor, index - 1)
                        "></v-select>
                  </div>
                  <div id="areaType" v-if="item.tipoInput == 'textarea'">
                    <span class="type-label-style">{{ item.txtLabel }}</span>
                    <v-textarea v-on:blur="
                      extraDataItems[index].textType == 'number'
                        ? null
                        : dynamicVModels[index].valor != ''
                          ? dynamicVModels[index].valor.trim()
                          : null
                      " :rules="dynamicRulesGen(item, index)" v-model="dynamicVModels[index].valor" class="mt-1"
                      outlined></v-textarea>
                  </div>
                  <div id="TODO_other"></div>
                </div>
              </v-row>
              <div id="3ros" v-if="show3ros == true && showInput == true">
                <span class="type-label-style" style="font-size: 14px; font-weight: bold">Montos Terceros:
                </span>
                <v-divider class="mt-1"></v-divider>
                <div v-for="(tercero, index) in terceros" :key="index">
                  <v-row class="mt-1">
                    <v-col cols="12" md="6" style="display: flex; align-items: center">
                      <span class="type-text-style" style="font-weight: unset">{{ tercero.d3nombre }}:</span>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field prefix="$" solo @keypress="validarRegex($event, 'ND')" v-model="tercero.monto"
                        required @click="
                          tercero.monto =
                          tercero.monto == 0 ? '' : tercero.monto
                          " :rules="validarMonto" @blur="
                            tercero.monto =
                            tercero.monto == ''
                              ? (tercero.monto = 0)
                              : tercero.monto
                            "></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div v-if="error3ros">
                  <span class="error-message-style mb-3">Todos los campos son requeridos</span>
                </div>
              </div>
              <div v-if="showMotivoNoLibBox == true" class="mt-8">
                <span class="type-label-style">Motivo de no liberación del vehículo</span>
                <v-select v-model="motivoNoLib" :items="motivosItems" item-text="mtmotivo" item-value="mtclave"
                  :rules="[(v) => !!v || 'Selección requerida']" solo persistent-hint></v-select>
              </div>

              <div v-if="montosErrorText == true" class="mb-3">
                <span class="error-message-style">
                  Debe ingresar al menos un monto</span>
              </div>

              <div class="mt-8">
                <span class="type-label-style">{{ labelObservaciones }}</span>

                <v-textarea v-on:blur="
                  observacionesSelected = observacionesSelected.trim()
                  " v-model="observacionesSelected" class="mt-1" outlined :counter="$store.state.maxLengthComentarios"
                  :maxlength="$store.state.maxLengthComentarios" :rules="rulestextarea"></v-textarea>
              </div>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#536DFE" dark v-on:click="saveMovimientoProcess()">Guardar</v-btn>
              <v-btn color="default" v-on:click="clearOptions()">
                Limpiar
              </v-btn>
              <v-btn color="#FF4081" dark v-on:click="goBack()">
                Cancelar
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import generalServices from "@/services/ReporteGeneral/ReporteGeneral.service.js";
export default {
  props: ["tokenData"],
  data() {
    return {
      validForm: true,
      respuestaText: "SI",
      encabezadoText: [],
      loaded: false,

      menuDatePickerGeneral: false,

      dateCollabsable: false,
      dateComponentConstraints: {},

      campoRequeridoRules: [(v) => !!v || "Campo requerido"],

      mailForRules: [(v) => !!v || "Campo requerido"],

      rulestextarea: [
        (v) => !!v || "Campo requerido",
        (v) => {
          if (v == null) {
            return true;
          } else {
            if (v.trim().length < 12) {
              return "Mínimo 12 Carácteres";
            } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
              return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
            } else return true;
          }
        },
      ],

      showAudienciaAcordada: false,
      audienciaAcordada: false,
      audienciaAcordadaItems: [],

      audicienciaPicker: false,
      audicienciaTimePicker: false,

      fechaAudienciaSelected: "",
      horaAudienciaSelected: "",

      dynamicInputsErrorMessage: false,
      dynamicInputsErrorMessageText: "Debe seleccionar al menos una opción",

      dynamicVModels: [],
      dynamicInputVmodels: [],

      extraDataItems: [],
      inputDinamicos: [],

      documentosTag: false,

      selectedDate: "",
      observacionesSelected: "",

      tokenClaveMovimiento: "",
      respuestaMovimiento: null,

      responsabilidadState: null,
      responsabilidadOpc: null,

      responsabilidadTercero: null,
      responsabilidadNa: null,

      allDocumentsValidation: null,

      motivoNoLib: "",
      motivosItems: [],

      mailSelected: 0,

      showMotivoNoLibBox: null,

      noMailsSelected: false,
      tempMails: [],

      vehiculoLiberado: 0,
      encabezadoInfo: [],

      //terceros
      show3ros: false,
      terceros: [],
      error3ros: false,
      respuesta: null,
      validarespuesta: false,
      showInput: false,

      documentosPoderAusa: false,
      subElementoTextfield: false,

      subElementoDynamicVModels: [],

      montosErrorText: null,

      mensajeTextoExtra: "\r\n",
      mensajeObservacionesExtra: "\r\n //",

      enableFacturaFisicaRadio: false,
      facturaFisicaRadioValue: null,

      datos: null,

      opciones: {
        Catalogo: [],
        clave: null
      },
      DatePicker: false,
      dislocalidad: true,
      opcionesLocalidad: {
        Catalogo: [],
        clave: null
      },
      mostrarfechas: false,
      DatePicker1: false,
      DatePicker2: false,
      fecha1: null,
      fecha2: null,
      subarrayFactura: null,
      subarrayBoleto: null,
      subarrayRadicacion: null,
      afianzadorasArray: [],
      labelObservaciones: 'Observaciones: ',
      //Desahogo de pruebas
      pruebas: [],
      prestaciones: [],
      mostrarPrestaciones: false,
      opcionesPr: [{ valor: 1, descripcion: 'Modifica' }, { valor: 2, descripcion: 'Confirma' }, { valor: 3, descripcion: 'Revoca' }],
      errorPrestacion: false,
      validaEstado: false,
      validaLocalidad: false,
      validaAfianzadora: false,


    };
  },
  async mounted() {
    this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    this.changeReporteMenuOption("NoView"); // NoView
    this.setMenuButtonSelected();
    this.getDatosGenerales();
    //this.testMethod();
  },
  methods: {
    ...mapMutations(["changeReporteMenuOption"]),

    setMenuButtonSelected() {
      let selectedOption = this.$route.name;
    },

    docCheckBoxInput(valor, checkboxId, itemData) {
      if (itemData.subelemento != null) {
        if (checkboxId == 214 && valor == true) {
          this.enableFacturaFisicaRadio = true;
          this.facturaFisicaRadioValue = false;
        }

        if (checkboxId == 214 && valor == false) {
          this.enableFacturaFisicaRadio = false;
          this.facturaFisicaRadioValue = null;
        }
      }
    },

    inputDinamicosCheck(index, item) {
      this.dynamicInputsErrorMessage = false;
      if (this.tokenClaveMovimiento == 745 && this.respuestaMovimiento == 1) {
        if (
          item.idNombre == "chDoctosAusa" &&
          this.dynamicInputVmodels[index].valor == true
        ) {
          //TODO: define the save method
          this.$swal({
            title: "¿Estás seguro?",
            text: "Al marcar este campo se marcará automaticamente la recepción de documentos",
            icon: "warning",
            allowEscapeKey: false,
            allowOutsideClick: false,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, estoy de acuerdo",
            cancelButtonText: "Cancelar",
          }).then((result) => {
            if (result.isConfirmed) {
              this.documentosPoderAusa = true;
            } else {
              this.dynamicInputVmodels[index].valor = false;
            }
          });
        }
        if (
          item.idNombre == "chDoctosAusa" &&
          this.dynamicInputVmodels[index].valor == false
        ) {
          //TODO: define the save method
          this.documentosPoderAusa = false;
        }

        if (
          this.dynamicInputVmodels[index].valor == true &&
          item.idNombre != "chDoctosAusa"
        ) {
          // AGREGAR EL .textLabel a this.mensajeTextoExtra
          this.mensajeTextoExtra =
            this.mensajeTextoExtra +
            (this.dynamicInputVmodels[index].textLabel.toString() + "\r\n");
          if (item.idNombre != "chDoctosAusa") {
            this.mensajeObservacionesExtra =
              this.mensajeObservacionesExtra +
              (this.dynamicInputVmodels[index].iniciales.toString() + "//");
          }
        }
        if (
          this.dynamicInputVmodels[index].valor == false &&
          item.idNombre != "chDoctosAusa"
        ) {
          // ELIMINAR EL .textLabel a this.mensajeTextoExtra
          var str =
            this.dynamicInputVmodels[index].textLabel.toString() + "\r\n";
          this.mensajeTextoExtra = this.mensajeTextoExtra.replace(str, "");

          if (item.idNombre != "chDoctosAusa") {
            var str2 =
              this.dynamicInputVmodels[index].iniciales.toString() + "//";
            this.mensajeObservacionesExtra =
              this.mensajeObservacionesExtra.replace(str2, "");
          }
        }

        let extraIndex = this.dynamicVModels.findIndex(
          (el) => el.textLabel === "txtMensaje"
        );
        let mensajeIndex = this.dynamicVModels[extraIndex].valor.indexOf(
          "documentos del vehículo:"
        );

        mensajeIndex = mensajeIndex + 25;

        // Input String
        let origString = this.extraDataItems[extraIndex].valor;

        // String to be added
        let stringToAdd = this.mensajeTextoExtra;
        // Position to add string
        let indexPosition = mensajeIndex;

        // Using slice method to split string
        let newString =
          origString.slice(0, indexPosition) +
          stringToAdd +
          origString.slice(indexPosition);
        if (item.idNombre != "chDoctosAusa") {
          this.dynamicVModels[extraIndex].valor = newString;
        }
      }
    },

    dynamicRulesGen(item, index) {
      var resultRules = [];
      try {
        if (item.idNombre == "tMontoDiaPen") {
          resultRules.push((v) => {
            if (this.dynamicVModels[index + 1].valor > 0) {
              if (v == null || v == "") {
                return "Campo requerido";
              } else if (v.length > 0) {
                resultRules.push(
                  (v) => new RegExp(item.regex).test(v) || "Inserte un valor valido"
                );
                //if (v == null || v == "") {
                //  return "Campo requerido";
                //}
                //if (parseFloat(v) < 9) {
                //  return "Inserte un valor valido";
                //}
                if (parseFloat(v) > this.dynamicVModels[index + 1].valor) {
                  return "Monto Diario Pensión NO puede ser mayor al Monto Pensión";
                }
                return true;
              } else return true;
            } else return true;
          });
        }

        if (item.idNombre == "tMontoPen") {
          resultRules.push((v) => {
            if (this.dynamicVModels[index - 1].valor > 0) {
              if (v == null || v == "") {
                return "Campo requerido";
              } else if (v.length > 0) {
                resultRules.push(
                  (v) => new RegExp(item.regex).test(v) || "Inserte un valor valido"
                );
                //if (v == null || v == "") {
                //  return "Campo requerido";
                //}
                //if (parseFloat(v) < 9) {
                //  return "Inserte un valor valido";
                //}
                return true;
              } else return true;
            } else return true;
          });
        }

        if (item.idNombre == "tMontoMulta") {
          resultRules.push((v) => {
            if (v != null) {
              if (v.length > 0) {
                resultRules.push(
                  (v) => new RegExp(item.regex).test(v) || "Inserte un valor valido"
                );
                //if (v == null || v == "") {
                //  return "Campo requerido";
                //}
                //if (parseFloat(v) < 9) {
                //  return "Inserte un valor valido";
                //}
                return true;
              } else return true;
            } else return true;
          });
        }

        if (item.idNombre == "tMontoGruas") {
          resultRules.push((v) => {
            if (v != null) {
              if (v.length > 0) {
                resultRules.push(
                  (v) => new RegExp(item.regex).test(v) || "Inserte un valor valido"
                );
                //if (v == null || v == "") {
                //  return "Campo requerido";
                //}
                //if (parseFloat(v) < 9) {
                //  return "Inserte un valor valido";
                //}
                return true;
              } else return true;
            } else return true;
          });
        }

        if (item.required == "SI" || item.required == "si") {
          if (
            ![
              "tCorreoPara",
              "tMontoDiaPen",
              "tMontoPen",
              "tMontoMulta",
              "tMontoGruas",
            ].includes(item.idNombre)
          ) {
            if (["sConceptoC",
              "sPresttacionC"
            ].includes(item.idNombre)) {
              resultRules.push((v) => v.length > 0 || "Campo requerido");
            } else {
              resultRules.push((v) => !!v || "Campo requerido");
            }

          }
        }
        if (item.regex != null) {
          if (
            ![
              "tCorreoPara",
              "tCorreoCopia",
              "tMontoDiaPen",
              "tMontoPen",
              "tMontoMulta",
              "tMontoGruas",
            ].includes(item.idNombre)
          ) {
            resultRules.push(
              (v) => new RegExp(item.regex).test(v) || "Inserte un valor valido"
            );
          }
        }
        if (item.idNombre == "tMontoAseg") {
          resultRules.push(
            (v) =>
              v === "" ||
              parseFloat(v) <= 5000000 ||
              "La cantidad máxima es 5,000,000"
          );
        }
        if (item.minLength >= 1) {
          resultRules.push((v) => {
            if (v == null || v == "") {
              return true;
            } else {
              if (v.trim().length < item.minLength) {
                return `Mínimo ${item.minLength} Carácteres`;
              } else if (v.trim().length > item.maxLength) {
                return `Máximo ${item.maxLength} Carácteres`;
              } else return true;
            }
          });
        }
      } catch (e) {
        console.log(e);
      }
      return resultRules;
    },

    async showMovMotivoNoLib() {
      let getTokenData = MetodosGenerales.getJsonTokenData(this.tokenData);

      let responseShowLibVeh = await generalServices.ObtenerShowMovMotivoNoLib(
        this.tokenClaveMovimiento,
        getTokenData,
        this.respuestaMovimiento
      );

      let showMotivo = responseShowLibVeh[0].showMotivo;

      if (showMotivo == 1 && this.vehiculoLiberado == 0) {
        this.showMotivoNoLibBox = true;
        return;
      } else {
        this.showMotivoNoLibBox = false;
        return;
      }
    },

    async selectValueChangeTrigger(item, value, index) {
      if (
        item.idNombre.toString().toLowerCase() == "sdiccausalidad" &&
        this.responsabilidadState == true
      ) {
        this.responsabilidadOpc = value;
      }

      if (item.idNombre.toString().toLowerCase() == "srespaudi") {
        if (value == 17) {
          this.showAudienciaAcordada = true;
        } else {
          this.showAudienciaAcordada = false;
        }
      }
      if (!this.mostrarPrestaciones) {
        if (!item.multiple) {
          var result = await this.dynamicVModels[index].opciones.filter((obj) => {
            return obj.valor === value;
          });
        } else {
          result = await this.dynamicVModels[index].opciones.filter((obj) => {
            return value.includes(obj.valor);
          });
        }

        if (result[0].subelemento != undefined) {
          result[0].subelemento.valor = "";
          this.subElementoDynamicVModels.splice(index, 1, result[0].subelemento);
          //this.subElementoDynamicVModels[index] = result.subelemento;
        } else {
          this.subElementoDynamicVModels.splice(index, 1);
        }
      }


      if (this.tokenClaveMovimiento == 851) {
        var valoresFactura = ['tmontoFC', 'tnumeroFC', 'sAfianzadoraC'];
        var valoresBoleto = ['tmontoBilleteC', 'tnumeroBilleteC'];
        if (value == 1) {
          this.dynamicVModels[1].valor = undefined;
          this.dynamicVModels[2].valor = undefined;
          this.dynamicVModels[3].valor = undefined;
          this.dynamicVModels[4].valor = undefined;
          this.dynamicVModels[5].valor = undefined;
          this.afianzadorasArray = await generalServices.ObtenerAfianzadoras();
          this.extraDataItems = this.extraDataItems.concat(this.subarrayFactura);
          this.extraDataItems = this.extraDataItems.filter(function (objeto) {
            return !valoresBoleto.includes(objeto.idNombre);
          });
        } else if (value == 2) {
          this.dynamicVModels[1].valor = undefined;
          this.dynamicVModels[2].valor = undefined;
          this.dynamicVModels[3].valor = undefined;
          this.dynamicVModels[4].valor = undefined;
          this.dynamicVModels[5].valor = undefined;
          this.extraDataItems = this.extraDataItems.concat(this.subarrayBoleto);
          this.extraDataItems = this.extraDataItems.filter(function (objeto) {
            return !valoresFactura.includes(objeto.idNombre);
          });
        } else {
          this.dynamicVModels[1].valor = undefined;
          this.dynamicVModels[2].valor = undefined;
          this.dynamicVModels[3].valor = undefined;
          this.dynamicVModels[4].valor = undefined;
          this.dynamicVModels[5].valor = undefined;
          this.extraDataItems = this.extraDataItems.filter(function (objeto) {
            return !valoresBoleto.includes(objeto.idNombre);
          });
          this.extraDataItems = this.extraDataItems.filter(function (objeto) {
            return !valoresFactura.includes(objeto.idNombre);
          });
        }
      }
      else if (this.tokenClaveMovimiento == 850) {
        var valoresRadicacion = ['tdiasCont', 'dFhRadicacion'];
        if (value == 1) {
          this.extraDataItems = this.extraDataItems.concat(this.subarrayRadicacion);
        } else {
          this.dynamicVModels[1].valor = undefined;
          this.dynamicVModels[2].valor = undefined;
          this.extraDataItems = this.extraDataItems.filter(function (objeto) {
            return !valoresRadicacion.includes(objeto.idNombre);
          });
        }
      }
      else if (this.tokenClaveMovimiento == 860) {
        this.errorPrestacion = false
      }

    },

    async getDatosGenerales() {
      let today = new Date().toJSON().slice(0, 10);
      this.selectedDate = today;
      //------
      let encabezado = await reporteExpJur.EncabezadoReporte(this);
      this.encabezadoInfo = encabezado;
      this.vehiculoLiberado = encabezado.LibVeh;
      let getTokenData = await MetodosGenerales.getJsonTokenData(
        this.tokenData
      );
      //------
      this.tokenClaveMovimiento = getTokenData.claveMovimiento;
      this.respuestaMovimiento = getTokenData.respuesta;
      //------
      await this.showMovMotivoNoLib();

      //.log("El show motivo hasta ahora: ", this.showMotivoNoLibBox);

      if (this.showMotivoNoLibBox == true) {
        if (
          [2, 4, 454, 746, 756, 748, 750].includes(this.tokenClaveMovimiento)
        ) {
          let data = new FormData();
          data.append("mtactivo", 1);
          data.append("mttipo", "V");
          data.append("ceclave", this.tokenClaveMovimiento);
          await generalServices.MotivosLibVehNoLib(this, data).then((data) => {
            this.motivoNoLib = 0;
            this.motivosItems = data;
          });
        }
      }

      if ([745, 746].includes(this.tokenClaveMovimiento)) {
        this.documentosTag = true;
      }

      if (getTokenData.respuesta == 0) {
        this.respuestaText = "NO"; // SETUP RESPUESTA TEXT
      }
      let response = await reporteExpJur.ObtenerDatosGeneralesMovimiento(
        this.datos,
        getTokenData.claveMovimiento
      );

      this.encabezadoText = response.tipoMovimiento.encabezado; //SET UP ENCABEZADO INFO
      this.dateComponentConstraints = response.fecha;

      // if (
      //   response.respuesta.opciones[
      //     this.respuestaText
      //   ].servicio.toLowerCase() != "sin servicio"
      // ) {
      let especificosResponse =
        await reporteExpJur.ObtenerEspecificosMovimiento(
          this.datos,
          getTokenData.claveMovimiento,
          getTokenData.respuesta
        );

      //console.log("Especificos: ", especificosResponse);
      this.inputDinamicos = especificosResponse.inputsDinamicos;

      if (this.inputDinamicos != undefined) {
        this.inputDinamicos.forEach((element) => {

          let body = {
            textLabel: element.txtlabel,
            idNombre: element.idNombre,
            docValor: element.valor,
          };
          if (element.tipoInput.toString().toLowerCase() == "checkbox") {
            body.valor = false;
          }

          if (element.tipoInput.toString().toLowerCase() == "select") {
            body.opciones = element.opciones;
            body.textLabel = element.txtLabel;
            body.valor = null;
            // text: descripcion  , value: valor
          }

          if (element.idNombre == "chDocumentos") {
            body.iniciales = element.inicials;
          }

          this.dynamicInputVmodels.push(body);

        });
      }
      this.extraDataItems = especificosResponse.inputs;

      this.extraDataItems.forEach((element) => {

        let body = {
          textLabel: element.idNombre,
          valor: null,
        };
        if (element.tipoInput.toString().toLowerCase() == "mailtextfield") {
          body.searchIteam = "";
          body.items = [];
          body.selectedItems = [];
        }
        if (element.textarea != "") {
          body.valor = element.valor;
        }
        if (
          element.tipoInput.toString().toLowerCase() == "select" ||
          element.tipoInput.toString().toLowerCase() == "selectcorreos"
        ) {
          body.opciones = element.opciones;
        }
        // dictamen es favorable/dictamen es contrario/dictamen es en corresponsabilidad
        if (
          [454, 478].includes(this.tokenClaveMovimiento) &&
          element.idNombre.toString().toLowerCase() == "sdiccausalidad"
        ) {
          this.responsabilidadState = true;
        }
        if (this.tokenClaveMovimiento != 848) {
          this.showInput = true;
        }
        if (element.idNombre.toString().toLowerCase() == "srespaudi") {
          this.audienciaAcordada = true;
          this.audienciaAcordadaItems = element.opciones[1].subelemento;
        }
        this.dynamicVModels.push(body);
      });

      this.loaded = true;
      this.dateCollabsable = true;

      if (this.tokenClaveMovimiento == 849) {
        await generalServices.ObtenerEstados(this);
      }
      if (this.tokenClaveMovimiento == 850) {
        var valoresRadicacion = ['tdiasCont', 'dFhRadicacion'];
        this.subarrayRadicacion = this.extraDataItems.filter(function (objeto) {
          return valoresRadicacion.includes(objeto.idNombre);
        });
        this.extraDataItems = this.extraDataItems.filter(function (objeto) {
          return !valoresRadicacion.includes(objeto.idNombre);
        });
      }
      if (this.tokenClaveMovimiento == 860) {
        this.prestaciones = await generalServices.ObtenerPrestacionesCivil(this.datos)
        this.mostrarPrestaciones = true;
      }
      if (this.tokenClaveMovimiento == 857) {
        /* mostar fechas, ojo ahorita esta fijo */
        this.pruebas = await generalServices.ObtenerPruebasAsistenciaCivil(this.datos)
        this.mostrarfechas = true;
      }
      if (this.tokenClaveMovimiento == 851) {
        var valoresFactura = ['tmontoFC', 'tnumeroFC', 'sAfianzadoraC'];
        var valoresBoleto = ['tmontoBilleteC', 'tnumeroBilleteC'];
        this.subarrayFactura = this.extraDataItems.filter(function (objeto) {
          return valoresFactura.includes(objeto.idNombre);
        });

        this.subarrayBoleto = this.extraDataItems.filter(function (objeto) {
          return valoresBoleto.includes(objeto.idNombre);
        });

        this.extraDataItems = this.extraDataItems.filter(function (objeto) {
          return !valoresFactura.includes(objeto.idNombre);
        });
        this.extraDataItems = this.extraDataItems.filter(function (objeto) {
          return !valoresBoleto.includes(objeto.idNombre);
        });

        this.showInput = true;
      }
      if ((this.tokenClaveMovimiento == 852 || this.tokenClaveMovimiento == 854) && this.respuestaText == 'NO') {
        this.labelObservaciones = '¿Por qué?: '
      }

    },

    async newSelectedMails(value, listIndex) {
      //TODO: append here the mails with the petion of item.servicio
      let correosResponse = await reporteExpJur.obtenerCorreosPorZona(
        this,
        value
      );
      if (this.tempMails.length > 0) {
        this.dynamicVModels[listIndex].selectedItems = this.dynamicVModels[
          listIndex
        ].selectedItems.filter((item) => !this.tempMails.includes(item));
      }
      correosResponse.data.forEach((element) => {
        this.tempMails.push(element.correo);
        this.dynamicVModels[listIndex].selectedItems.push(element.correo);
        this.mailSelected++;
      });
    },

    clearMailSearch(listIndex) { },

    resetItemsSelector(event, item, listIndex) {
      if (this.dynamicVModels[listIndex].valor != null) {
        this.mailSelected++;
        this.dynamicVModels[listIndex].selectedItems.push(
          this.dynamicVModels[listIndex].valor
        );
        this.dynamicVModels[listIndex].searchIteam = null;
        this.dynamicVModels[listIndex].items = null;
      }
    },

    deleteFromList(index, item) {
      this.dynamicVModels[index].selectedItems = this.dynamicVModels[
        index
      ].selectedItems.filter((element) => element !== item);

      if (this.dynamicVModels[index].selectedItems.length == 0) {
        this.dynamicVModels[index].valor = null;
      }
      this.mailSelected--;
    },

    addMailValider(event, item, listIndex) {
      if (
        RegExp(item.regex).test(this.dynamicVModels[listIndex].searchIteam) ==
        true
      ) {
        this.dynamicVModels[listIndex].items = [
          {
            value: this.dynamicVModels[listIndex].searchIteam,
            text: this.dynamicVModels[listIndex].searchIteam,
          },
        ];
      }
    },

    goBack() {
      //TODO: Pop up message for user confirmation on cancel operation
      this.$router.go(-1);
    },

    async clearOptions() {
      //TODO: define what a clear option will do: CLEAR EVERYTHING FROM date to below
      this.$swal({
        position: "center",
        title: "Cargando...",
        html: "Espere un momento, por favor",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      this.menuDatePickerGeneral = false;
      this.dateCollabsable = false;
      this.dateComponentConstraints = {};
      this.showAudienciaAcordada = false;
      this.audienciaAcordada = false;
      this.audienciaAcordadaItems = [];
      this.audicienciaPicker = false;
      this.audicienciaTimePicker = false;
      this.fechaAudienciaSelected = "";
      this.horaAudienciaSelected = "";
      this.dynamicInputsErrorMessage = false;
      this.dynamicInputsErrorMessageText =
        "Debe seleccionar al menos una opción";
      this.dynamicVModels = [];
      this.dynamicInputVmodels = [];
      this.extraDataItems = [];
      this.inputDinamicos = [];
      this.documentosTag = false;
      this.selectedDate = "";
      this.observacionesSelected = "";
      this.tokenClaveMovimiento = "";
      this.respuestaMovimiento = null;
      this.responsabilidadState = null;
      this.responsabilidadOpc = null;
      this.responsabilidadTercero = null;
      this.responsabilidadNa = null;
      this.allDocumentsValidation = null;
      this.motivoNoLib = "";
      this.motivosItems = [];
      this.mailSelected = 0;
      this.showMotivoNoLibBox = null;
      this.noMailsSelected = false;
      this.tempMails = [];
      this.vehiculoLiberado = 0;
      this.encabezadoInfo = [];
      //terceros
      this.show3ros = false;
      this.terceros = [];
      this.error3ros = false;
      this.respuesta = null;
      this.validarespuesta = false;
      this.showInput = false;
      this.documentosPoderAusa = false;
      this.mensajeTextoExtra = "\r\n";
      this.mensajeObservacionesExtra = "\r\n ";
      this.montosErrorText = null;
      await this.getDatosGenerales();
      this.$refs.form.resetValidation();
      this.$swal.close();
      this.dislocalidad = true;
    },

    async extraValidations() {
      let getTokenData = MetodosGenerales.getJsonTokenData(this.tokenData);
      var valida = true;
      this.dynamicInputsErrorMessage = false;
      if (
        getTokenData.claveMovimiento == 745 &&
        this.respuestaMovimiento == 1
      ) {
        if (this.mailSelected == 0) {
          this.$swal({
            position: "center",
            icon: "error",
            title: "Inserte al menos un correo valido",
            html: "Por favor llene al menos un correo",
            showConfirmButton: true,
          });
          valida = false;
        }

        let minimoUno = 0;
        if (this.dynamicInputVmodels.length == 0) {
          minimoUno++;
        } else {
          this.dynamicInputVmodels.forEach((element) => {
            if (element.valor == true) {
              minimoUno++;
            }
          });
        }

        if (minimoUno < 1) {
          this.dynamicInputsErrorMessage = true;
          this.dynamicInputsErrorMessageText =
            "Debe seleccionar al menos una opción";
          valida = false;
        }
      }

      if (getTokenData.claveMovimiento == 746) {
        let doctosSelected = 0;
        this.dynamicInputVmodels.forEach((element) => {
          if (element.valor == true) {
            doctosSelected++;
          }
        });

        if (
          getTokenData.respuesta == 1 &&
          doctosSelected != this.dynamicInputVmodels.length
        ) {
          this.dynamicInputsErrorMessage = true;
          this.dynamicInputsErrorMessageText =
            "Si no cuenta con todos los documentos, debe generar el movimiento en la respuesta NO";
          valida = false;
        }

        if (
          getTokenData.respuesta == 0 &&
          doctosSelected == this.dynamicInputVmodels.length
        ) {
          this.dynamicInputsErrorMessage = true;
          this.dynamicInputsErrorMessageText =
            "Si cuenta con todos los documentos, debe generar el movimiento en la respuesta SI";
          valida = false;
        }
        // if (getTokenData.respuesta == 0 && doctosSelected == 0) {
        //   this.dynamicInputsErrorMessage = true;
        //   this.dynamicInputsErrorMessageText =
        //     "Debe seleccionar al menos una opción";
        //   valida = false;
        // }
      }
      if (getTokenData.claveMovimiento == 848) {
        if (this.show3ros) {
          this.terceros.forEach((tercero) => {
            tercero.monto = tercero.monto == "" ? 0 : tercero.monto;
          });
        }
        this.validarespuesta = this.respuesta == null ? true : false;
      }
      if (getTokenData.claveMovimiento == 860) {
        let val = 0;
        this.prestaciones.forEach((prestacion) => {
          if (prestacion.pciRespuesta != 0) {
            val++
          }
        });
        this.errorPrestacion = val == 0 ? true : false;
        valida = val == 0 ? false : true;
      }

      return valida;
    },

    async saveMovimientoProcess() {
      try {
        this.$swal({
          position: "center",
          title: "Cargando...",
          html: "Espere un momento por favor",
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirm: false,
        });

        this.$swal.showLoading();

        this.$refs.form.validate();
        let cancontinue = true;

        if (this.documentosPoderAusa == false) {
          let extraValid = await this.extraValidations();
          let formValidation = this.$refs.form.validate();
          if (extraValid == false || formValidation == false) {
            let errorMessageText =
              "Por favor llene o verifique que los datos sean correctos en los campos marcados";

            if (this.tokenClaveMovimiento == 745 && this.mailSelected == 0) {
              errorMessageText =
                "Por favor inserte al menos un correo electrónico válido";
            }

            this.$swal({
              position: "center",
              icon: "info",
              title: "Llene todos los campos correctamente",
              html: errorMessageText,
              showConfirmButton: true,
            });
            cancontinue = false;
          }
        }

        if (this.documentosPoderAusa == true) {
          let formValidation = this.$refs.form.validate();

          if (formValidation == false) {
            let errorMessageText =
              "Por favor llene o verifique que los datos sean correctos en los campos marcados";

            this.$swal({
              position: "center",
              icon: "info",
              title: "Llene todos los campos correctamente",
              html: errorMessageText,
              showConfirmButton: true,
            });
            cancontinue = false;
          }
        }

        if (this.tokenClaveMovimiento == 752) {
          this.montosErrorText = null;
          let oneMonto = 0;
          this.dynamicVModels.forEach((element) => {
            if (element.valor > 0) {
              oneMonto++;
            }
          });
          if (oneMonto == 0) {
            this.$swal({
              position: "center",
              icon: "info",
              title: "Llene todos los campos correctamente",
              html: "Por favor llene o verifique que los datos sean correctos en los campos marcados",
              showConfirmButton: true,
            });
            cancontinue = false;
            this.montosErrorText = true;
          }
        }

        if (this.tokenClaveMovimiento == 849) {
          this.validaEstado = this.dynamicVModels[6].valor == undefined ? true : false;
          this.validaLocalidad = this.dynamicVModels[7].valor == undefined ? true : false;

          if (this.validaEstado == true || this.validaLocalidad == true) {
            let errorMessageText =
              "Por favor llene o verifique que los datos sean correctos en los campos marcados";

            this.$swal({
              position: "center",
              icon: "info",
              title: "Llene todos los campos correctamente",
              html: errorMessageText,
              showConfirmButton: true,
            });
            cancontinue = false;
          }
        }
        if (this.tokenClaveMovimiento == 851) {
          if (this.dynamicVModels[0].valor == 1) {
            this.validaAfianzadora = this.dynamicVModels[3].valor == undefined ? true : false;
          } else {
            this.validaAfianzadora = false;
          }

          if (this.validaAfianzadora == true) {
            let errorMessageText = "Por favor llene o verifique que los datos sean correctos en los campos marcados";
            this.$swal({
              position: "center",
              icon: "info",
              title: "Llene todos los campos correctamente",
              html: errorMessageText,
              showConfirmButton: true,
            });
            cancontinue = false;
          }
        }

        if (cancontinue == true) {
          let movimientoBody = {};
          let getTokenData = MetodosGenerales.getJsonTokenData(this.tokenData);

          movimientoBody.ClaveMovimiento = getTokenData.claveMovimiento;
          movimientoBody.Reporte = getTokenData.nrreporte;
          movimientoBody.Indice = getTokenData.svindice;



          movimientoBody.dFechaMov = this.selectedDate;
          movimientoBody.sRespMov = this.respuestaText;
          movimientoBody.txtObsMov = MetodosGenerales.SanitizarTexto(this.observacionesSelected);

          this.dynamicVModels.forEach((element) => {
            if (
              element.valor != undefined &&
              element.valor != null &&
              element.valor != ""
            ) {
              movimientoBody[element.textLabel] = element.valor;
            }

            if (
              element.selectedItems != undefined &&
              element.selectedItems != null
            ) {
              movimientoBody[element.textLabel] =
                element.selectedItems.toString();
            }
          });

          let tempDocObject = [];
          this.dynamicInputVmodels.forEach((element) => {
            if (element.idNombre == "chDocumentos") {
              if (element.valor == true) {
                tempDocObject.push(element.docValor);
              }
            }
          });

          this.subElementoDynamicVModels.forEach((element) => {
            element.forEach((subElement) => {
              movimientoBody[subElement.idNombre] = subElement.valor;
            });
          });

          // 1- Informe --> No se envia nada
          // 2- Favorable --> Se envia responsabilidad de tercero --> responsabilidadTercero
          // 3- Contrario --> Se envia responsabilidad de NA --> responsabilidadNa
          // 4- Corresponsabilidad --> Se envian AMBAS --> (responsabilidadTercero,responsabilidadNa)
          // 5- No se emitio --> No se envia nada
          if (this.responsabilidadState == true) {
            if (this.responsabilidadOpc == 2) {
              movimientoBody.RTerceroRespon =
                this.responsabilidadTercero == true ? 1 : 0;
            }
            if (this.responsabilidadOpc == 3) {
              movimientoBody.RNaRespon = this.responsabilidadNa == true ? 1 : 0;
            }
            if (this.responsabilidadOpc == 4) {
              movimientoBody.RTerceroRespon =
                this.responsabilidadTercero == true ? 1 : 0;
              movimientoBody.RNaRespon = this.responsabilidadNa == true ? 1 : 0;
            }
          }

          if (this.show3ros) {
            let d3ids = [];
            let d3montos = [];

            this.terceros.forEach((tercero) => {
              d3ids.push(tercero.d3id);
              d3montos.push(tercero.monto);
            });
            movimientoBody.d3ids = d3ids.join();
            movimientoBody.d3montos = d3montos.join();
          }
          movimientoBody.rEmitio = parseInt(this.respuesta);
          /* if(movimientoBody.rEmitio == 0){
          movimientoBody.monto
        } */

          movimientoBody.chDocumentos = tempDocObject.join();

          if (movimientoBody.tCorreoPara != undefined) {
            if (
              movimientoBody.tCorreoPara != "" &&
              movimientoBody.tCorreoPara != null
            ) {
              movimientoBody.tCorreoPara =
                movimientoBody.tCorreoPara.replaceAll(",", ";");
            }
          }

          if (movimientoBody.tCorreoCopia != undefined) {
            if (
              movimientoBody.tCorreoCopia != "" &&
              movimientoBody.tCorreoCopia != null
            ) {
              movimientoBody.tCorreoCopia =
                movimientoBody.tCorreoCopia.replaceAll(",", ";");
            }
          }

          if (this.documentosPoderAusa == true) {
            movimientoBody.chDoctosAusa = 1;
          }
          if (this.showAudienciaAcordada == true) {
            movimientoBody.dFhAudiencia = this.fechaAudienciaSelected;
            movimientoBody.dHrAudiencia = this.horaAudienciaSelected;
          }

          let formattedMovimientoBody = [];
          if (!this.documentosPoderAusa && this.tokenClaveMovimiento == 745) {
            movimientoBody.txtObsMov =
              movimientoBody.txtObsMov + this.mensajeObservacionesExtra;
          }

          if (this.enableFacturaFisicaRadio == true) {
            movimientoBody.rFactFis = this.facturaFisicaRadioValue;
          }

          if (this.tokenClaveMovimiento == 849) {
            movimientoBody.sEstado = movimientoBody.sEstado.clave;
            movimientoBody.sLocalidad = movimientoBody.sLocalidad.clave;
            movimientoBody.sPresttacionC = movimientoBody.sPresttacionC.join();

          } else if (this.tokenClaveMovimiento == 851) {
            if (movimientoBody.sEmbargo == 1) {
              movimientoBody.sAfianzadoraC = movimientoBody.sAfianzadoraC.afclave;
            }
          } else if (this.tokenClaveMovimiento == 856) {
            movimientoBody.sConceptoC = movimientoBody.sConceptoC.join();
          } else if (this.tokenClaveMovimiento == 857) {
            let opctipo = [];
            let fecha = [];

            this.pruebas.forEach((prueba) => {
              opctipo.push(prueba.opctipo);
              fecha.push(prueba.fecha);
            });
            movimientoBody.pruebaOpctipo = opctipo.join();
            movimientoBody.pruebaFecha = fecha.join();
          } else if (this.tokenClaveMovimiento == 853) {
            movimientoBody.sPresttacionC = movimientoBody.sPresttacionC.join();
          } else if (this.tokenClaveMovimiento == 860) {
            let pcitipo = [];
            let respuestas = [];

            this.prestaciones.forEach((prestacion) => {
              if (prestacion.pciRespuesta != 0) {

                pcitipo.push(prestacion.pcitipo);
                respuestas.push(prestacion.pciRespuesta);
              }
            });

            movimientoBody.prestacionPcitipo = pcitipo.join();
            movimientoBody.prestacionRespuestas = respuestas.join();
          }

          formattedMovimientoBody.push(movimientoBody);

          let movimientoResponse = await reporteExpJur.guardarMovimiento(
            this,
            JSON.stringify(formattedMovimientoBody)
          );

          if (movimientoResponse.success === "false") {
            this.$swal({
              position: "center",
              icon: "error",
              title: "Ops...",
              html: movimientoResponse.mensaje,
              showConfirmButton: true,
              timer: 3000,
            }).then(() => {
              //this.$router.go(-1);
            });
            return;
          }
          this.$emit("ReloadEncabezado");
          this.$swal({
            position: "center",
            icon: "success",
            title: "Exito!",
            html: movimientoResponse.mensaje,
            showConfirmButton: true,
            timer: 3000,
          }).then(() => {
            this.$router.go(-1);
          });
        }
      } catch (e) {
        console.log("La exception: ", e);
        this.$swal({
          position: "center",
          icon: "error",
          title: "Algo salio mal",
          html: "Algo salio mal, por favor intente de nuevo mas tarde",
          showConfirmButton: true,
        });
      }
    },
    async ObtenerTerceros() {
      this.terceros = await generalServices.ObtenerTerceros(this, this.datos);
      this.show3ros = this.terceros.length > 0 ? true : false;
    },
    validarRegex(evt, tipo) {
      return MetodosGenerales.validarRegex(evt, tipo);
    },
    async ObtenerLocalidad(esclave) {
      this.validaEstado = false;
      await generalServices.ObtenerLocalidades(this, esclave.clave);
      this.dislocalidad = false;
    },
    SeleccionarLocalidad() {
      this.validaLocalidad = false;
    },
    SeleccionarAfianzadora() {
      this.validaAfianzadora = false;
    }
  },
  watch: {
    // selectedDate(newDate, oldDate) {
    //   //Cierra el collapsable al escojer otra fecha.
    //   // if (this.dateCollabsable == true) {
    //   //   document.getElementById("datePickerCollapse").click();
    //   // }
    // },
    respuesta(val) {
      if (val != null) {
        this.validarespuesta = false;
        this.showInput = val == 1 ? true : false;
        if (this.showInput == true) {
          this.error3ros = false;
          this.ObtenerTerceros();
        } else {
          this.show3ros = false;
          this.terceros = [];
          this.dynamicVModels[1].valor = 0;
        }
      }
    },

  },
  computed: {
    validarMonto() {
      return [
        (v) =>
          v === "" ||
          parseFloat(v) <= 5000000 ||
          "La cantidad máxima es 5,000,000",
      ];
    },
  },
};
</script>
<style>
.addMovimientoClassList .vs-collapse-item--header {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  background-color: #e0e0e0 !important;
}

.addMovimientoClassList .con-content--item {
  padding: 0px !important;
}
</style>
<style scoped>
.card-title-style {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 1.1em;
  color: white;
}

.title-card-style {
  padding: 1.5px !important;
  max-height: auto;
}

.collapsable-container {
  background-color: white;
  height: 100% !important;
}

.type-label-style {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 12px;
}

.type-text-style {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 1.3em;
}

.date-card-title-text {
  margin-top: 1px !important;
  margin-bottom: 1px !important;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: rgb(59, 59, 59);
}

.calendar-container-style {
  padding: 0px !important;
}

.document-chekboxes-style {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 12px;
}

.error-message-style {
  font-family: "Roboto", sans-serif;
  color: red;
  font-weight: 400;
  font-size: 12px;
}
</style>
